/** Logo de marca según el tema (pedido Eduardo 2026-08-16).
 *
 * En modo claro el logo "on-dark" (texto blanco) es invisible sobre el fondo
 * claro del login. Lee el MISMO storage key que AppShell para decidir; sin
 * preferencia guardada aplica el default de la app (oscuro). Las pantallas
 * de login no tienen toggle de tema, así que basta leerlo al renderizar.
 */
const THEME_STORAGE_KEY = "cymergold_tenis_theme";

export function torneos123HeaderLogoSrc(): string {
  const isLight =
    typeof window !== "undefined" &&
    window.localStorage.getItem(THEME_STORAGE_KEY) === "light";
  const variant = isLight ? "on-light" : "on-dark";
  return `${import.meta.env.BASE_URL}torneos123/logo-torneos123-header-${variant}.png`;
}
